import { render, staticRenderFns } from "./shopsSetting.vue?vue&type=template&id=255fbd67&scoped=true"
import script from "./shopsSetting.vue?vue&type=script&lang=js"
export * from "./shopsSetting.vue?vue&type=script&lang=js"
import style0 from "./shopsSetting.vue?vue&type=style&index=0&id=255fbd67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255fbd67",
  null
  
)

export default component.exports